import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill={'#e8eaed'} viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M212.31-140Q182-140 161-161t-21-51.31v-535.38Q140-778 161-799t51.31-21h535.38Q778-820 799-799t21 51.31v535.38Q820-182 799-161t-51.31 21zm0-60h134.15v-146.46H200v134.15q0 5.39 3.46 8.85t8.85 3.46m194.15 0h147.08v-146.46H406.46zm207.08 0h134.15q5.39 0 8.85-3.46t3.46-8.85v-134.15H613.54zM200-406.46h146.46v-147.08H200zm206.46 0h147.08v-147.08H406.46zm207.08 0H760v-147.08H613.54zM200-613.54h146.46V-760H212.31q-5.39 0-8.85 3.46t-3.46 8.85zm206.46 0h147.08V-760H406.46zm207.08 0H760v-134.15q0-5.39-3.46-8.85t-8.85-3.46H613.54z"
      ></path>
    </svg>
  );
}

export default Icon;
